import React, { useState } from 'react';
import Context from './context';

const ContextProvider = ({ children }) => {
  const [state, setState] = useState(null);

  return (
    <Context.Provider value={{ state, setState }}>
      {children}
    </Context.Provider>
  );
};

export default ContextProvider;
